;(function() {
/* @ngInject */
function DizajnerObjednaneController(CompletedOrderService, $window, $filter){
    let vm = this;
    let server = CompletedOrderService;

    vm.payment = "movement";
    vm.showMovement = false;
    vm.downloadLabel = $filter("translate")('payments.documents.general');

    server.getCompletedOrderData().then(onPaymentInfoLoad);

    function onPaymentInfoLoad(payment) {
        if(payment) {
            vm.orderId = payment.orderId;
            vm.price = payment.price;
            vm.paymentData = payment;
            vm.invoiceHref = `/invoice/download?orderId=${payment.orderId}`;
            vm.proformaHref = `/invoice/download?proforma=true&orderId=${payment.orderId}`;

        } else {
            $window.location = "/";
        }
    }
}

angular.module("firmaren")
    .controller("DizajnerObjednaneController", DizajnerObjednaneController);
}());
